import React, { useState, useEffect } from "react";
import AgentCurrency from "./AgentCurrency";
import btcImage from "../../assets/images/btc.png";
import ethImage from "../../assets/images/eth.png";
import usdtethImage from "../../assets/images/usdt-erc20.png";
import usdcethImage from "../../assets/images/usdc-erc20.png";
import trxImage from "../../assets/images/trx.png";
import ltcImage from "../../assets/images/ltc.png";
import xrpImage from "../../assets/images/xrp.png";
import dogeImage from "../../assets/images/doge.png";
import { CryptoCurrencies } from "../../enums/CryptoCurrenciesCombo";
import { Networks } from "../../enums/networks";
import Copyright from "../../internals/components/Copyright";
import { CircularProgress, Box, Grid, Typography } from "@mui/material";
import { getAgentCryptoCurrencies } from "../../actions/agent";
import { useNavigate } from "react-router";

const AgentCryptoCurrencies = ({ token, isAuthenticated, setIsAuthenticated }) => {
	const [cryptoCurrencies, setCryptoCurrencies] = useState(null);
	const navigate = useNavigate();

	const getImageByCryptoNetwork = (cryptoCurrency, network) => {
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				return btcImage;
			case CryptoCurrencies.ETHEREUM:
				return ethImage;
			case CryptoCurrencies.USDT:
				if (network === Networks.ETHEREUM) {
					return usdtethImage;
				} else {
					return usdtethImage;
				}
			case CryptoCurrencies.USDC:
				if (network === Networks.ETHEREUM) {
					return usdcethImage;
				} else {
					return usdcethImage;
				}
			case CryptoCurrencies.TRX:
				return trxImage;
			case CryptoCurrencies.DOGECOIN:
				return dogeImage;
			case CryptoCurrencies.LITECOIN:
				return ltcImage;
			case CryptoCurrencies.XRP:
				return xrpImage;
			default:
				return null;
		}
	};

	useEffect(() => {
		getAgentCryptoCurrencies(token, (data) => {
			if (!data.error) {
				setCryptoCurrencies(data.data);
			} else {
				if (data.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, []);

	return (
		<>
			{cryptoCurrencies ? (
				<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
					{/* cards */}
					<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
						Settings
					</Typography>
					<Grid container spacing={2} columns={12} sx={{ mb: (theme) => theme.spacing(2) }}>
						{cryptoCurrencies.map((curr, index) => (
							<Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
								<AgentCurrency
									cryptoCurrency={curr.cryptoCurrency}
									network={curr.network}
									image={getImageByCryptoNetwork(curr.cryptoCurrency, curr.network)}
									activeDeposit={curr.activeDeposit}
									activeWithdrawal={curr.activeWithdrawal}
									freeplay={curr.freePlay}
									freeplayAmount={curr.freePlayPercentage}
									token={token}
								/>
							</Grid>
						))}
					</Grid>
					<Copyright sx={{ my: 4 }} />
				</Box>
			) : (
				<CircularProgress color="primary" size={80} thickness={5} />
			)}
		</>
	);
};

export default AgentCryptoCurrencies;
